import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomerIdLinkIdField from "../../customers/CustomerIdLinkIdField";
import CustomTableSmall from "../../unit/CustomTableSmall";

const DashboardSearchCustomer = ({ ...props }) => {
  const searchResult = Array.isArray(props.searchResult)
    ? props.searchResult
    : [];
  return (
    <TableContainer sx={{ maxHeight: 440 }}>
      <CustomTableSmall
        key={"dashboardSearchCustomer"}
        id="table-dashboard-search-customers"
        stickyHeader
        aria-label="sticky table"
      >
        <TableHead>
          <TableRow>
            <TableCell
              sx={{ minWidth: "100px" }}
              className="hm-table-header"
              align="center"
            >
              User #
            </TableCell>
            <TableCell className="hm-table-header">Sign Up Channel</TableCell>
            <TableCell className="hm-table-header">Borrower Name</TableCell>
            {/* <TableCell>Email</TableCell> */}
            {/* <TableCell sx={{ minWidth: "150px" }}>Mobile</TableCell> */}
            {/* <TableCell sx={{ minWidth: "120px" }}>Signup Time</TableCell> */}
            {/* <TableCell sx={{ minWidth: "120px" }}>Last Login Time</TableCell> */}
            <TableCell
              sx={{
                width: "120px",
                textAlign: "center",
              }}
              className="hm-table-header"
            >
              Number of Applications
            </TableCell>
            {/* <TableCell>Loans</TableCell> */}
            <TableCell
              sx={{
                width: "120px",
                textAlign: "center",
              }}
              className="hm-table-header"
            >
              Active Loans
            </TableCell>
            <TableCell
              sx={{
                width: "120px",
                textAlign: "center",
              }}
              className="hm-table-header"
            >
              Paid-Off Loans
            </TableCell>
            <TableCell
              sx={{
                width: "120px",
                textAlign: "center",
              }}
              className="hm-table-header"
            >
              Charged-Off Loans
            </TableCell>
            <TableCell
              sx={{
                width: "120px",
                textAlign: "center",
              }}
              className="hm-table-header"
            >
              Financial Accounts
            </TableCell>
            <TableCell
              sx={{
                width: "120px",
                textAlign: "center",
              }}
              className="hm-table-header"
            >
              Payment Accounts
            </TableCell>
            {/* <TableCell>State</TableCell>
            <TableCell sx={{ minWidth: "120px" }}>Zip</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {searchResult == undefined ||
          searchResult.length == 0 ||
          searchResult == null ? (
            <TableRow>
              <TableCell colSpan={8}>No Data </TableCell>
            </TableRow>
          ) : (
            searchResult.map((row: any, index: number) => (
              // Customers: User ID [linked to the Individual Customer Page], Login Email, Name, Financial Coach, …
              <TableRow key={index} sx={{ maxHeight: "40px" }}>
                <TableCell align="center">
                  <CustomerIdLinkIdField id={row?.id} />
                </TableCell>
                <TableCell>{row?.sCouponCode}</TableCell>
                <TableCell>
                  {row?.sFname} {row?.sLname}
                </TableCell>
                {/* <TableCell>{row?.sEmail}</TableCell> */}
                {/* <TableCell>{row?.sMobile}</TableCell> */}
                {/* <TableCell>
                  {row?.signup_time
                    ? row?.signup_time.substring(6, 10) +
                      "-" +
                      row?.signup_time.substring(0, 2) +
                      "-" +
                      row?.signup_time.substring(3, 5)
                    : null}
                </TableCell> */}
                {/* <TableCell>{formatDate(row?.last_login_time)}</TableCell> */}
                <TableCell
                  sx={{ width: "120px", textAlign: "center" }}
                  className="numericText"
                >
                  {row?.appnum + row?.loansnum}
                </TableCell>
                {/* <TableCell>{row?.loansnum}</TableCell> */}
                <TableCell
                  sx={{
                    width: "120px",
                    textAlign: "center",
                  }}
                  className="numericText"
                >
                  {row?.loanActiveNum}
                </TableCell>
                <TableCell
                  sx={{
                    width: "120px",
                    textAlign: "center",
                  }}
                  className="numericText"
                >
                  {row?.loanPaidOffNum}
                </TableCell>
                <TableCell
                  sx={{
                    width: "120px",
                    textAlign: "center",
                  }}
                  className="numericText"
                >
                  {row?.loanChargedOffNum}
                </TableCell>
                <TableCell
                  sx={{ width: "120px", textAlign: "center" }}
                  className="numericText"
                >
                  {row?.plaidAccount}
                </TableCell>
                <TableCell
                  sx={{ width: "120px", textAlign: "center" }}
                  className="numericText"
                >
                  {row?.plaidAccount_ach}
                </TableCell>
                {/* <TableCell>{row?.state}</TableCell> */}
                {/* <TableCell>{row?.zip}</TableCell> */}
              </TableRow>
            ))
          )}
        </TableBody>
      </CustomTableSmall>
    </TableContainer>
  );
};
export default DashboardSearchCustomer;
